import i18next from 'i18next'
import { List } from 'immutable'
import React from 'react'
import { Link } from 'widgets-for-react'

export type BreadcrumbItem = {
  label: string
  url: string
}

export type BreadcrumbProps = {
  items: List<BreadcrumbItem>
}

export function generateBreadcrumbs(
  ignoreLast: number = 0
): List<BreadcrumbItem> {
  const currentUri = window.location.pathname
  const pathSegmentArray = currentUri.split('/').slice(2, -1) // excludes first (language) and last (current page) segment
  const crumbsAsArrays: string[][] = []
  for (let index = 0; index < pathSegmentArray.length; index++) {
    crumbsAsArrays.push(pathSegmentArray.slice(0, index + 1))
  }
  return List(
    crumbsAsArrays.map((crumbArray) => ({
      url: `/${i18next.language}/`.concat(crumbArray.join('/')),
      label: crumbArray[crumbArray.length - 1],
    }))
  ).take(pathSegmentArray.length - ignoreLast)
}

export function getLastSegment(url: string): string {
  return url.split('/').pop() || ''
}

export const BreadcrumbLayout = (p: BreadcrumbProps) => (
  <nav
    className="breadcrumb"
    aria-label={i18next.t('a11y:navLabelBreadcrumbs')}
  >
    <ul className="breadcrumb__list text--s">
      {p.items.map((item) => {
        return (
          <li className="breadcrumb__item" key={item.url}>
            <Link
              to={`${item.url.startsWith('/') ? '' : '/'}${item.url}`}
              className="breadcrumb__link link--inverted-grey"
            >
              {i18next.t(`route:${item.label}`)}
            </Link>
          </li>
        )
      })}
    </ul>
  </nav>
)
